import QRCode from "qrcode";
import { track } from "./analytics-client.js";

window.DropQRCode = { ...QRCode, toCanvas(canvas, value, options) {
  if (typeof value === "string" && value.includes("/events.html?id=")) {
    const url = new URL(value); url.searchParams.set("utm_source", "event_qr"); url.searchParams.set("utm_medium", "qr"); value = url.toString();
  }
  return QRCode.toCanvas(canvas, value, options);
} };
window.DropAnalytics = { track };
const eventId = new URLSearchParams(location.search).get("id");
if (eventId) track("event_visit", { eventId });
const nativeFetch = window.fetch.bind(window);
window.fetch = async (input, init) => {
  const response = await nativeFetch(input, init);
  const url = String(typeof input === "string" ? input : input?.url || "");
  const upload = url.match(/\/api\/events\/([^/]+)\/uploads(?:\/[^/]+\/complete)?(?:\?|$)/);
  if (response.ok && upload && String(init?.method || "GET").toUpperCase() === "POST") {
    track(url.includes("/complete") ? "event_upload_completed" : "event_upload_started", { eventId: upload[1] });
  }
  return response;
};
await import("./events-app-v2.js");
